export const CELL_TYPES = {
  TITLE: "TITLE",
  FIXED: "FIXED",
  INPUT: "INPUT",
  DROPDOWN: "DROPDOWN",
  TEXT_ALIGNED: "TEXT_ALIGNED",
  MATH_JAX: "MATH_JAX",
  IMAGE: "IMAGE",
  IMAGE_TITLE: "IMAGE_TITLE",
};

export const DATA_TYPE = {
  STRING: "string",
  NUMBER: "number",
};
